// eslint-disable-next-line no-restricted-imports
import { ManagerFragment } from 'api/generated/graphql';
import { ManagerData } from 'api/types/data';
import { parseFullName } from 'helpers';

export const parseManagerData = (manager: ManagerFragment): ManagerData => ({
  id: manager.id,
  name: parseFullName(manager),
});
